import {
    CheckmarkTitle,
    CommentsTitle,
    IconClockTable,
    IconCloseChip,
} from '../../../../../components/buttons/IconButtons';
import { STATUS_MODEL } from '../../../../../enums/statusEnum';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */

export const STATUS_ICON_MODEL = {
    [STATUS_MODEL.APPROVED]: { Icon: CheckmarkTitle },
    [STATUS_MODEL.CHANGES_REQUESTED]: { Icon: CommentsTitle },
    [STATUS_MODEL.DENIED]: { Icon: IconCloseChip },
    [STATUS_MODEL.PENDING_REVIEW]: { Icon: IconClockTable },
};

export const DOCUMENTATION_APPROVAL_USER_STATUS = [
    STATUS_MODEL.DRAFT,              // 157
    STATUS_MODEL.PENDING_REVIEW,     // 133
    STATUS_MODEL.CHANGES_REQUESTED,  // 131
    STATUS_MODEL.DENIED,             // 132
    STATUS_MODEL.APPROVED            // 130
];
